import { Button } from '@codeparva/ui-components-library';
import React from 'react';

export const PaymentField = ({
  shouldShowHostedForm,
  hidePaymentDetails = true,
  disableBtn,
}: {
  shouldShowHostedForm: boolean;
  hidePaymentDetails?: boolean;
  disableBtn: boolean;
}) => {
  const shouldDisabledButton = () => disableBtn || hidePaymentDetails;

  return (
    <div className="paymentButtonContainer">
      <Button
        type="submit"
        className={`cp-primary-button-highlighted has-text-secondary ${
          shouldShowHostedForm ? 'is-loading' : ''
        }`}
        fullwidth={true}
        data-testid="payment-btn"
        disabled={shouldDisabledButton()}
      >
        {hidePaymentDetails ? 'No Due Balance' : 'Process Payment'}
      </Button>
    </div>
  );
};
